export const singularize = (text) => {
  const endIndex = text.length - 1;
  const isPlural = text.charAt(endIndex) === "s";

  return isPlural ? text.substr(0, endIndex) : text;
};
